import React from 'react';
import SocialMenu from '../../components/public/SocialMenu';

const RedesSociaisPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <SocialMenu onClose={() => window.history.back()} />
      </div>
    </div>
  );
};

export default RedesSociaisPage;
